import React from "react";
import useGlobalStore from "../stores/globalStore";

export default function TvFlexChannels({ isVisible, flexChannels }) {
  //Store
  const flexCategories = useGlobalStore((state) => state.flexCategories);
  const selectedTvPackages = useGlobalStore((state) => state.selectedTvPackages);
  const selectedFlexChannels = useGlobalStore((state) => state.selectedFlexChannels);
  const toggleSelectedFlexChannels = useGlobalStore((state) => state.toggleSelectedFlexChannels);

  //Functions
  const handleToggleFlexChannel = (channel) => {
    if (selectedFlexChannels.some((selectedChannel) => selectedChannel.id === channel.id)) {
      toggleSelectedFlexChannels(channel);
      return;
    }

    if (selectedTvPackages.some((pack) => pack.title.includes("Flex 7"))) {
      if (selectedFlexChannels.length === 7) return;
      toggleSelectedFlexChannels(channel);
      return;
    }
    if (selectedTvPackages.some((pack) => pack.title.includes("Flex 14"))) {
      if (selectedFlexChannels.length === 14) return;
      toggleSelectedFlexChannels(channel);
      return;
    }
  };

  return (
    <>
      <p className={isVisible ? "tel-pt-view-description" : "tel-pt-view-description not-visible"}>
        Välj {selectedTvPackages.some((pack) => pack.title.includes("Flex 14")) ? "14" : "7"} valfria kanaler för ditt
        FLEX-paket.
      </p>

      <div
        className={
          isVisible ? "tel-pt-channels tel-pt-tv-flex-channels" : "tel-pt-channels tel-pt-tv-flex-channels not-visible"
        }
      >
        {flexCategories &&
          flexCategories.map((flexCat) => (
            <>
              <h4>{flexCat.title}</h4>
              <ul className="tel-pt-channels__list">
                {flexChannels &&
                  flexChannels
                    .filter((channel) => channel.isFlex && channel.kanal_kategorier.includes(flexCat.title))
                    .map((channel: any) => (
                      <li
                        className={`tel-pt-channels__list-item ${
                          selectedFlexChannels.some((pkg) => pkg.id === channel.id) ? "selected" : ""
                        } ${
                          selectedTvPackages.some((pack) => pack.title.includes("Flex 7")) &&
                          selectedFlexChannels.length === 7 &&
                          !selectedFlexChannels.some((pkg) => pkg.id === channel.id) &&
                          "tel-pt-disabled"
                        }
                      ${
                        selectedTvPackages.some((pack) => pack.title.includes("Flex 14")) &&
                        selectedFlexChannels.length === 14 &&
                        !selectedFlexChannels.some((pkg) => pkg.id === channel.id) &&
                        "tel-pt-disabled"
                      }`}
                        key={channel.id}
                        onClick={() => handleToggleFlexChannel(channel)}
                      >
                        <span>{channel.title.replace(/&#038;/g, "&")}</span>
                      </li>
                    ))}
              </ul>
            </>
          ))}
      </div>
    </>
  );
}
